import { defaultDescription, defaultId, defaultName, defaultStatus, defaultStatusMsg, defaultTime } from "./shared.js";

// Column definitions.
const name = { ...defaultName, minWidth: 150 };
const description = { ...defaultDescription, minWidth: 200 };
const createdOn = { ...defaultTime("created_on"), headerName: "Created on" };
const updatedOn = { ...defaultTime("updated_on"), headerName: "Updated on" };
const status = { ...defaultStatus({ queueIsProcessed: true }) };
const statusMsg = { ...defaultStatusMsg };

// Table columns.
export const columns = (props) => [defaultId, name, description, status, createdOn, updatedOn, statusMsg];

// Style and other misc. functions.
export const isRowSelectable = (props, params) => {
    return true;
};

// Default aggregate props of the table.
export const defaultTableOptions = {
    isRowSelectable,
    checkboxSelection: true
};
